import PropTypes from 'prop-types'
import React from 'react'
import ResponsiveImage from 'components/images/responsive-image'
import { PICKUP_HOW_IT_WORKS as CON } from 'pages/pomelo-pickup/const'
import HowItWorksItem from '../how-it-works-item'
import styles from './styles.scss'

const HowItWorksSection = ({ isPhone, t }) => {
  const img = CON.banner[isPhone ? 0 : 1]

  return (
    <section className="pickup-hiw__wrapper">
      <style jsx>{styles}</style>
      <ul className="pickup-hiw__list">
        {CON.content.map((content) => (
          <HowItWorksItem key={content.title} t={t} content={content} />
        ))}
      </ul>
      <ResponsiveImage
        className="pickup-hiw__img"
        imgRatio={img.ratio}
        src={img.src}
      />
    </section>
  )
}

HowItWorksSection.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

export { HowItWorksSection }
export default HowItWorksSection
